module.exports = __webpack_public_path__ + "img/premiumVector.6a9d7049.svg";